var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcActionLink',{attrs:{"close-after-click":true,"href":_vm.downloadUrl,"download":_vm.downloadUrl,"aria-label":_vm.title}},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n\t"),_vm._t("icon",null,{"slot":"icon"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }